import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Agenda tu Sesión',
  desc: 'Elige un horario en el Calendly de abajo (20 min).'
}, {
  num: '02',
  title: 'Diseño de Arquitectura',
  desc: 'Analizamos tus metas y capacidad de ahorro.'
}, {
  num: '03',
  title: 'Activación del Blindaje',
  desc: 'Implementamos el plan con certeza contractual.'
}];
export function HowItWorks() {
  return <Section bg="navy-light" data-id="element-85">
      <div className="text-center mb-8 md:mb-16" data-id="element-86">
        <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6" data-id="element-87">
          ¿Cómo Funciona?
        </h2>
        <div className="w-16 md:w-24 h-1 bg-gold mx-auto" data-id="element-88"></div>
      </div>

      <div className="relative max-w-4xl mx-auto" data-id="element-89">
        {/* Connecting Line (Desktop) */}
        <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-gold/0 via-gold/50 to-gold/0" data-id="element-90"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-91">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="relative text-center" data-id="element-92">
              <div className="w-16 h-16 md:w-24 md:h-24 mx-auto bg-navy rounded-full border-2 border-gold flex items-center justify-center mb-4 md:mb-6 shadow-[0_0_30px_rgba(201,168,76,0.15)] relative z-10" data-id="element-93">
                <span className="text-2xl md:text-3xl font-playfair font-bold text-gold" data-id="element-94">
                  {step.num}
                </span>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3" data-id="element-95">
                {step.title}
              </h3>
              <p className="text-gray-light text-sm md:text-base" data-id="element-96">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}